export default __webpack_public_path__ + "static/media/arrowDown.8d4a9ac9.svg";